(function ($) {
  $('.lottie').each(function () {
    var $this = $(this);
    var lottieType = $this.attr('class').includes('lottie--')
      ? $this
          .attr('class')
          .split(' ')
          .find(
            (className) =>
              className.includes('lottie--') &&
              !className.includes('lottie--fg') &&
              !className.includes('lottie--bg')
          )
          .replace('lottie--', '')
      : null;
    if (lottieType) {
      $this.append('<div></div>');

      var lottieContainer = $this.children('div')[0];
      var lottiePath =
        window.location.origin +
        '/wp-content/themes/ernest/assets/animations/' +
        lottieType +
        '/' +
        lottieType +
        '-2.json';

      window.addEventListener('load', function (params) {
        var params = {
          container: lottieContainer,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: lottiePath,
        };

        var anim;

        setTimeout(() => {
          anim = lottie.loadAnimation(params);
          anim.addEventListener('DOMLoaded', function() {
            var svgElements = lottieContainer.querySelector('svg >g');
            
            if (!svgElements) return;
            
            if (svgElements.closest('.banner-hero')) {

              if (document.querySelector('.banner-hero__media >a')) {
                const videoUrl = document.querySelector('.banner-hero__media >a').getAttribute('href');

                if (videoUrl !== "") {
                  svgElements.classList.add('video-play');
                  svgElements.setAttribute('href', videoUrl);
                }
              }
            }
          });
        }, 0);
      });
    }
  });
})(jQuery);
